var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card card-default chat-box",
      staticStyle: { "min-height": "600px" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "card-header pt-1 pb-1 pl-0 pr-0 border-bottom ml-1 mr-1 align-items-center",
        },
        [
          _c("strong", { class: { "text-danger": _vm.session.block } }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", {}, [
                _c("img", {
                  staticClass: "round",
                  attrs: {
                    src:
                      _vm.friend.avatar !== null
                        ? _vm.friend.avatar.url
                        : "/images/avatar.png",
                    alt: "avatar",
                    height: "30",
                    width: "30",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "h4 pt-05 ml-05" }, [
                  _c(
                    "a",
                    {
                      staticClass: "text-dark",
                      attrs: {
                        href: "/member/profiles/" + _vm.friend.username,
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.friend.first_name) +
                          " " +
                          _vm._s(_vm.friend.last_name)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isTyping
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.__("chat.is_typing")) + " . . ."),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.session.block
                  ? _c("span", [
                      _vm._v("(" + _vm._s(_vm.__("chat.blocked")) + ")"),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown float-right" }, [
            _c("a", { attrs: { href: "/member/messages" } }, [
              _c("button", { staticClass: "btn-sm btn-outline-primary" }, [
                _vm._v(_vm._s(_vm.__("chat.back_to_messages"))),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [{ name: "chat-scroll", rawName: "v-chat-scroll" }],
          staticClass: "card-body",
        },
        _vm._l(_vm.chats, function (chat) {
          return _c("p", {
            key: chat.id,
            staticClass: "card-text single-message",
            class: {
              "text-message-right": chat.type == 0,
              "text-success": chat.read_at != null,
            },
            domProps: {
              innerHTML: _vm._s(_vm.nl2br(chat.message) + _vm.dateSpan(chat)),
            },
          })
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "card-footer p-2",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.send.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "form-group",
              staticStyle: { position: "relative" },
            },
            [
              _c("div", { staticClass: "d-flex" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.message,
                      expression: "message",
                    },
                  ],
                  ref: "textarea",
                  staticClass: "input-message form-control",
                  attrs: {
                    rows: "1",
                    placeholder: "Write your message here",
                    disabled: _vm.session.block,
                    autofocus: "",
                  },
                  domProps: { value: _vm.message },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.message = $event.target.value
                      },
                      function ($event) {
                        return _vm.resize()
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "btn btn-primary btn-send-message" },
                  [
                    _c("i", { staticClass: "feather icon-send" }),
                    _vm._v(" " + _vm._s(_vm.__("chat.send"))),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("emoji-picker", {
                attrs: { search: _vm.search },
                on: { emoji: _vm.append },
                scopedSlots: _vm._u([
                  {
                    key: "emoji-invoker",
                    fn: function (ref) {
                      var clickEvent = ref.events.click
                      return _c(
                        "div",
                        {
                          staticClass: "emoji-invoker",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return clickEvent.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                height: "24",
                                viewBox: "0 0 24 24",
                                width: "24",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: { d: "M0 0h24v24H0z", fill: "none" },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    },
                  },
                  {
                    key: "emoji-picker",
                    fn: function (ref) {
                      var emojis = ref.emojis
                      var insert = ref.insert
                      var display = ref.display
                      return _c("div", {}, [
                        _c(
                          "div",
                          {
                            staticClass: "emoji-picker",
                            style: {
                              top: display.y + "px",
                              left: display.x + "px",
                            },
                          },
                          [
                            _c("div", { staticClass: "emoji-picker__search" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.search,
                                    expression: "search",
                                  },
                                ],
                                attrs: { type: "text", autofocus: "" },
                                domProps: { value: _vm.search },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.search = $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              _vm._l(emojis, function (emojiGroup, category) {
                                return _c("div", { key: category }, [
                                  _c("h5", [_vm._v(_vm._s(category))]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "emojis" },
                                    _vm._l(
                                      emojiGroup,
                                      function (emoji, emojiName) {
                                        return _c(
                                          "span",
                                          {
                                            key: emojiName,
                                            attrs: { title: emojiName },
                                            on: {
                                              click: function ($event) {
                                                return insert(emoji)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(emoji))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.showImageUpload
                ? _c("vue-dropzone", {
                    ref: "chatImageDropzone",
                    attrs: { id: "dropzone", options: _vm.dropzoneOptions },
                    on: { "vdropzone-success": _vm.uploadSuccess },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showFileUpload
                ? _c("vue-dropzone", {
                    ref: "chatFileDropzone",
                    attrs: {
                      id: "dropzoneFile",
                      options: _vm.dropzoneFileOptions,
                    },
                    on: { "vdropzone-success": _vm.uploadSuccessFile },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { attrs: { id: "show_options_chat" } }, [
                _c(
                  "div",
                  {
                    staticClass: "d-flex",
                    attrs: { id: "post_options_layer_chat" },
                  },
                  [
                    _c("div", { staticClass: "pl-0" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            id: "upload_images",
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            "data-original-title": "Upload Image",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showImageUpload = !_vm.showImageUpload
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "far fa-image",
                            staticStyle: {
                              "font-size": "1.5em",
                              "margin-bottom": "10px",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "file-icon",
                          attrs: {
                            id: "upload_file",
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            "data-title": "Attach File",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showFileUpload = !_vm.showFileUpload
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-paperclip",
                            staticStyle: {
                              "font-size": "1.5em",
                              "margin-bottom": "10px",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }